import moment from "moment";

const EXPLICIT_TIMEZONE = /(Z|[+-]\d{2}:?\d{2})$/i;

const toTimestamp = (value) => {
  if (!value) {
    return null;
  }

  const parsed =
    typeof value === "string" && EXPLICIT_TIMEZONE.test(value)
      ? moment.parseZone(value)
      : moment.utc(value);

  return parsed.isValid() ? parsed.valueOf() : null;
};

export const getDurationSeconds = (durationInMinutes) => {
  const duration = Number(durationInMinutes);

  return Number.isFinite(duration) && duration > 0
    ? Math.round(duration * 60)
    : 0;
};

export const parseElapsedTime = (elapsedTime) => {
  if (typeof elapsedTime !== "string") {
    return 0;
  }

  const parts = elapsedTime.split(":").map(Number);

  if (
    parts.length < 2 ||
    parts.length > 3 ||
    parts.some((part) => !Number.isFinite(part) || part < 0)
  ) {
    return 0;
  }

  return parts.reduce((total, part) => total * 60 + part, 0);
};

export const getElapsedSeconds = (team, now = Date.now()) => {
  const startedAt = toTimestamp(team?.gameStartedAt);

  if (startedAt === null) {
    return parseElapsedTime(team?.elapsedTime);
  }

  const finishedAt = toTimestamp(team?.gameFinishedAt);
  const end = finishedAt ?? now;

  return Math.max(0, Math.floor((end - startedAt) / 1000));
};

export const getTeamTimer = (team, now = Date.now()) => {
  const durationSeconds = getDurationSeconds(team?.roomDuration);
  const elapsedSeconds = getElapsedSeconds(team, now);

  return {
    durationSeconds,
    elapsedSeconds,
    displayElapsedSeconds: Math.min(elapsedSeconds, durationSeconds),
    remainingSeconds: Math.max(0, durationSeconds - elapsedSeconds),
    expired: durationSeconds > 0 && elapsedSeconds >= durationSeconds,
  };
};

export const formatTimer = (seconds) => {
  const safeSeconds = Math.max(0, Math.floor(Number(seconds) || 0));
  const minutes = Math.floor(safeSeconds / 60);
  const remainingSeconds = safeSeconds % 60;

  return `${String(minutes).padStart(2, "0")}:${String(
    remainingSeconds
  ).padStart(2, "0")}`;
};
